<template>
    <v-container>
        <v-layout justify-center wrap style="position: relative">

            <v-flex xs12>
                <w-main-title
                    class="pb-0"
                    title="Agenda"
                    :breadcrumbs="breadcrumbs"
                ></w-main-title>
            </v-flex>

        </v-layout>

        <v-scroll-y-transition>
            <v-alert
                v-show="locked && showAlertFirstTime"
                icon="fas fa-exclamation-circle"
                type="error"
            >Alguien mas esta modificando esta agenda.
            </v-alert>
        </v-scroll-y-transition>


        <v-layout wrap align-center justify-center>

            <v-flex xs12>
                <v-alert outline class="kim-card white" border="left" dismissible :value="true" color="primary">

                    - <b>Click izquierdo:</b> bloquear <br>
                    - <b>Click derecho:</b> desbloquear

                    <v-divider dark class="my-1"></v-divider>
                    <small>*Los cambios no serán realizados hasta presionar el botón <b>guardar</b>.</small>
                </v-alert>
            </v-flex>

            <v-flex xs12 sm8 text-xs-center text-sm-left>
                <v-btn :disabled="locked" class="ma-0" fab small outline @click="prev">
                    <v-icon>fas fa-chevron-left</v-icon>
                </v-btn>

                <v-list-tile class="month-nav-header">
                    <v-list-tile-content>
                        <v-list-tile-title class="text-xs-center">

                            <v-menu
                                v-model="calMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <span class="month-title" v-on="on"
                                          v-if="!locked">{{ $moment(date).format('MMMM YYYY').toUpperCase() }}</span>
                                    <span class="month-title"
                                          v-else>{{ $moment(date).format('MMMM YYYY').toUpperCase() }}</span>
                                </template>
                                <v-date-picker color="primary" locale="es-es" v-model="date"
                                               @input="calMenu = false"></v-date-picker>
                            </v-menu>

                        </v-list-tile-title>

                    </v-list-tile-content>
                </v-list-tile>

                <v-btn :disabled="locked" class="ma-0" fab small outline @click="next">
                    <v-icon>fas fa-chevron-right</v-icon>
                </v-btn>
            </v-flex>

            <v-flex xs12 sm4 text-xs-center text-sm-right>
                <v-btn :disabled="locked" fab flat small @click="$refs.configDialog.show()">
                    <v-icon>fas fa-sliders-h</v-icon>
                </v-btn>
                <v-btn
                    :loading="loadingSave"
                    :disabled="!scheduleEventsHasChanged || locked"
                    depressed
                    small
                    round
                    color="primary"
                    @click="saveWeek"
                >Guardar
                </v-btn>
            </v-flex>

            <v-flex xs12>

                <v-sheet height="400" @mousedown.prevent="startCapturing" @mouseup.prevent="stopCapturing"
                         @contextmenu.prevent="">

                    <v-scale-transition>
                        <div v-show="loading || loadingSave || locked" class="overlay">
                            <v-progress-circular
                                v-if="!locked"
                                :size="70"
                                :width="1"
                                color="primary"
                                indeterminate
                            ></v-progress-circular>
                        </div>
                    </v-scale-transition>

                    <kimsa-calendar
                        ref="calendar"
                        :events="events"
                        :capturing="capturingIntervals"
                        v-on:click-interval="onIntervalClicked"
                        v-on:change="onCalendarChange"
                        v-on:week-change="onWeekChange"
                        v-on:capture-interval="onIntervalCaptured"
                        :week-days="weekDays"
                        :value="date"
                        :interval-count="intervalCount"
                        :first-interval="intervalStart"
                        :interval-minutes="intervalMinutes"
                    >

                        <template v-slot:interval-block="{time}">
                            <div class="interval-block">{{ time }}</div>
                        </template>

                        <template v-slot:event="{event, index, timeToY, minutesToPixels, date}">
                            <div
                                v-if="event.client"
                                :key="date + event.time + index"
                                :style="{ top: timeToY(event.time) + 'px', height: minutesToPixels(intervalMinutes) + 'px' }"
                                :class="['kimsa-event', 'client']"
                            >
                                <v-avatar class="black--text">
                                    <v-icon left size="18">fas fa-user-clock</v-icon>
                                    {{ `${event.client.first_name} ${event.client.last_name[0]}.` }}
                                </v-avatar>
                            </div>
                            <div
                                v-else
                                :key="date + event.time + index"
                                :style="{ top: timeToY(event.time) + 'px', height: minutesToPixels(intervalMinutes) + 'px' }"
                                :class="['kimsa-event', {'primary': event.isNew}, {'secondary': !event.isNew}, {'error': event.delete}, {'client': event.client}]"
                                v-html="event.time"
                            >
                            </div>
                        </template>

                    </kimsa-calendar>
                </v-sheet>
            </v-flex>
            <v-flex xs12 pa-2 text-xs-center text-sm-right>

                <v-chip small>
                    <v-icon left color="white" size="16">fas fa-circle</v-icon>
                    Horas disponibles
                </v-chip>

                <v-chip small>
                    <v-icon left color="primary" size="16">fas fa-circle</v-icon>
                    Horas a bloquear
                </v-chip>

                <v-chip small>
                    <v-icon left color="secondary" size="16">fas fa-circle</v-icon>
                    Horas bloqueadas
                </v-chip>

                <v-chip small>
                    <v-icon left color="error" size="16">fas fa-circle</v-icon>
                    Horas a desbloquear
                </v-chip>
            </v-flex>
        </v-layout>
        <kimsa-confirm
            :close-on-confirm="false"
            :close-on-cancel="false"
            :loading="loadingSave"
            cancel-label="continuar sin guardar"
            confirm-label="guardar"
            ref="saveDialog"
            title="Guardar los cambios"
            content="Tienes cambios sin guardar, deseas guardarlos antes de continuar?"
            v-on:confirm="onSaveConfirm"
            v-on:cancel="onCancelConfirm"
        />
        <schedule-config
            ref="configDialog"
            v-on:success="onConfigUpdate"
            :calendar-start="currentWeek.start"
            :calendar-end="currentWeek.end"
            :schedule-id="$route.params.id"
            :week-days-value="weekDays"
            :interval-start-value="intervalStart"
            :interval-end-value="intervalEnd"
            :interval-minutes-value="intervalMinutes"
            :name-value="name"
            :appointment-anticipation-hours-value="appointmentAnticipationHours"
            :appointment-limit-days-value="appointmentLimitDays"
            :auto-schedule="schedule && schedule.auto_schedule"
            :request-online-payment-value="schedule && schedule.request_online_payment"
            :new-auto-schedule-events="newAutoScheduleEvents"
            @request-current-events="setNewAutoScheduleEvents"

        />
        <v-dialog v-model="eventModal" persistent max-width="500">
            <v-card v-if="selectedEvent">
                <v-card-title>
                    <h1 class="title">Detalle de la cita</h1>
                    <v-spacer></v-spacer>
                    <v-icon @click="eventModal = false">far fa-times-circle</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 caption>
                            Fecha:
                        </v-flex>
                        <v-flex xs12 px-2 pt-2 ml-2>
                            {{ $moment(`${selectedEvent.date} ${selectedEvent.time}`).format('dddd DD MMM | HH:mm') }}
                            hrs.
                        </v-flex>
                        <v-flex xs12 px-1 pb-2 ml-2>
                            <v-chip small dark :color="selectedEvent.confirmed ? 'success' : 'error'">
                                <v-icon size="16" class="mr-1">{{ selectedEvent.confirmed ? 'fa-check' : 'fa-clock' }}
                                </v-icon>
                                {{ selectedEvent.confirmed ? 'confirmada' : 'sin confirmar' }}
                            </v-chip>
                        </v-flex>
                        <v-flex xs12 caption>
                            Paciente:
                        </v-flex>
                        <v-flex xs12 pa-2 ml-2>
                            {{ selectedEvent.client.first_name }} {{ selectedEvent.client.last_name }}
                        </v-flex>
                        <v-flex xs12 caption>
                            Contacto:
                        </v-flex>
                        <v-flex xs12 pa-2>
                            <div>
                                <v-icon color="secondary" size="16" class="mr-1 ml-2">fas fa-envelope</v-icon>
                                <span>{{ `${selectedEvent.client.email || 'no disponible'}` }}</span>
                            </div>
                            <span>
                                <v-icon color="secondary" size="15" class="mr-1 ml-2">fas fa-phone</v-icon>
                                    <span>{{ `${selectedEvent.client.phone1 || 'no disponible'}` }}</span>
                            </span>
                            <span>
                                <v-icon color="secondary" size="15" class="mr-1 ml-2">fas fa-phone</v-icon>
                                <span>{{ `${selectedEvent.client.phone2 || 'no disponible'}` }}</span>
                            </span>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>

import WMainTitle from '@/components/common/WMainTitle'
import KimsaCalendar from '@/components/common/KimsaCalendar'
import ScheduleConfig from '@/components/providers/schedule/ScheduleConfig'
import KimsaConfirm from '@/components/common/KimsaConfirm'

import {mapMutations, mapState} from 'vuex'
import {ApiUtils} from '@/utils/ApiUtils'
import {debounce} from "@/utils/Common";
import {whisperOnPrivate, listenPrivateWhisper, leaveChannel} from '@/utils/Sockets'

export default {
    components: {
        WMainTitle,
        KimsaCalendar,
        KimsaConfirm,
        ScheduleConfig
    },
    data(vm) {
        return {
            eventModal: false,
            selectedEvent: null,
            showAlertFirstTime: false,
            scheduleId: null,
            calMenu: false,
            locked: false,
            locking: null,
            lockingOthers: null,
            loading: false,
            loadingSave: false,
            confirmSaveAction: 'next',
            capturingIntervals: false,
            capturingDelete: false,
            term: '',
            name: '',

            newAutoScheduleEvents: [],

            intervalMinutes: 60,
            intervalStart: '08:00',
            intervalEnd: '18:00',
            intervalCount: 13,
            appointmentAnticipationHours: this.intervalMinutes * 24, //minutes
            appointmentLimitDays: 7,
            currentWeek: {
                start: '',
                end: ''
            },
            events: [],
            originalEvents: [],
            weekDays: [1, 2, 3, 4, 5, 6, 0],
            date: this.$moment().format('YYYY-MM-DD'),
            schedule: [],
            breadcrumbs: [
                {
                    text: 'Listado Agendas',
                    to: vm.$route.name === 'panel.provider.schedule.details' ?
                        {name: 'panel.provider.schedule'} : {name: 'panel.provider.my_schedules'},
                    exact: true,
                },
                {
                    text: 'Modificar',
                    disabled: true,
                    to: ''
                }
            ],
        }
    },
    created() {
        var vm = this
        vm.scheduleId = vm.$route.params.id
        listenPrivateWhisper(`schedule.${vm.$route.params.id}`, 'lock', vm.whileLocked)
        document.addEventListener('beforeunload', vm.stopLockingOthers)
    },
    mounted() {
        var vm = this
        setTimeout(function () {
            vm.showAlertFirstTime = true
        }, 1500)
        vm.setLocking()

        console.log('breadcrumbs',vm.breadcrumbs)
    },
    beforeDestroy() {
        var vm = this
        vm.stopLockingOthers()
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        setNewAutoScheduleEvents() {

            var vm = this
            const allEvents = vm.events.filter(evt => !evt.extra)
            var eventsMap = allEvents
                .map(evt => {
                    return {
                        day: vm.$moment(evt.date).day(),
                        time: evt.time
                    }
                }).filter(evt => vm.weekDays.includes(evt.day))

            const result = [];
            for (const item of eventsMap) {

                if (result.find(evt => evt.day === item.day && evt.time === item.time)) {
                    continue
                }

                result.push(item)

            }

            vm.newAutoScheduleEvents = result

        },
        showEvent(event) {
            var vm = this
            vm.selectedEvent = event
            vm.eventModal = true
        },
        stopLockingOthers() {
            var vm = this
            clearInterval(vm.lockingOthers)
            vm.lockingOthers = null
            leaveChannel(`schedule.${vm.scheduleId}`)
        },
        setLocking() {
            var vm = this
            vm.locked = true
            clearTimeout(vm.locking)
            vm.locking = setTimeout(function () {
                vm.locked = false
            }, 1000)
        },
        whileLocked(locked) {
            var vm = this
            if (locked.by !== vm.currentUser.id && !vm.lockingOthers) {
                vm.setLocking()
            }
        },
        prev() {
            var vm = this
            if (vm.scheduleEventsHasChanged) {
                vm.confirmSaveAction = 'prev'
                vm.$refs.saveDialog.show()
            } else {
                vm.$refs.calendar.prev()
            }
        },
        next() {
            var vm = this
            if (vm.scheduleEventsHasChanged) {
                vm.confirmSaveAction = 'next'
                vm.$refs.saveDialog.show()
            } else {
                vm.$refs.calendar.next()
            }
        },
        redirectCalendarNav() {
            var vm = this
            vm.$refs.saveDialog.hide()
            if (vm.confirmSaveAction === 'next') {
                vm.$refs.calendar.next()
            } else {
                vm.$refs.calendar.prev()
            }
        },
        onCancelConfirm() {
            var vm = this
            vm.redirectCalendarNav()
        },
        async onSaveConfirm() {
            var vm = this
            var saved = await vm.saveWeek(false)
            if (saved) {
                vm.redirectCalendarNav()
            }
        },
        async saveWeek(resetEvents = true) {
            var vm = this

            if (vm.loadingSave || vm.locked) return false

            if (vm.allEvents.length === 0) {
                vm.showSnackBar('No hay cambios sin guardar')
                return
            }

            vm.loadingSave = true
            const response = await ApiUtils.makePatch(`schedules/${vm.$route.params.id}/events`, null, {
                events: vm.allEvents
            })
            vm.loadingSave = false

            if (!response.ok) {
                const json = await response.json()
                vm.toast(json.message || 'Ha ocurrido un error actualizando la agenda', 'error')
                return false
            }

            const json = await response.json()
            if (resetEvents) {
                await vm.getScheduleDetails(true)
            }
            vm.$nextTick(function () {
                vm.$refs.configDialog.saveAutoSchedule(true)
            })
            vm.toast('Cambios guardados correctamente')
            return true

        },
        onConfigUpdate(schedule) {
            const vm = this
            vm.getScheduleDetails()
        },
        startCapturing(evt) {
            var vm = this
            vm.capturingDelete = evt.which === 3
            vm.capturingIntervals = true
        },
        stopCapturing(evt) {
            var vm = this
            vm.capturingIntervals = false
        },
        onWeekDaysChange(days) {
            this.weekDays = days
        },
        onCalendarChange(val) {
            this.date = val
        },
        onWeekChange(dates) {
            var vm = this
            var lastDate = vm.$moment(dates.end.date).add(1, 'days').format('YYYY-MM-DD')
            vm.currentWeek = {
                start: dates.start.date,
                end: lastDate
            }
        },
        onIntervalClicked(evt, interval) {

            var vm = this

            if (interval.event && interval.event.client) {
                vm.showEvent(interval.event)
                return
            }

            if (interval.past) {
                vm.showSnackBar('No es posible modificar eventos pasados')
                return
            }

            const capturingDelete = evt.which === 3
            vm.setEvent(interval, capturingDelete)

        },
        onIntervalCaptured(interval) {
            var vm = this

            if (interval.past) {
                vm.showSnackBar('No es posible modificar eventos pasados')
                return
            }

            vm.setEvent(interval, vm.capturingDelete)

        },
        setEvent(interval, capturingDelete = false) {

            var vm = this
            if (interval.event) {

                if (capturingDelete) {

                    if (interval.event.client) {
                        vm.showSnackBar('No se pueden eliminar eventos ya reservados.')
                        return
                    }

                    if (interval.event.id) {
                        interval.event.delete = 1
                        var event = JSON.parse(JSON.stringify(interval.event))
                        vm.events.splice(interval.event.index, 1)
                        vm.events.push(event)
                    } else {
                        vm.events.splice(interval.event.index, 1)
                    }
                    return
                }

                if (interval.event.id) {
                    delete interval.event.delete
                    var event = JSON.parse(JSON.stringify(interval.event))
                    vm.events.splice(interval.event.index, 1)
                    vm.events.push(event)
                }
                return
            }

            if (capturingDelete) return

            var newEvent = {
                title: 'Bloqueado',
                isNew: 1,
                date: interval.date,
                time: interval.time
            }

            vm.events.push(newEvent)

        },
        async getScheduleDetails(firstLoad = false) {

            var vm = this

            if (!vm.currentWeek.start || !vm.currentWeek.end || vm.locked) return

            vm.loading = true
            var response = await ApiUtils.makeGet(`provider/schedules/${vm.$route.params.id}`, {
                events_start_date: vm.currentWeek.start,
                events_end_date: vm.currentWeek.end
            })
            vm.loading = false

            if (!response.ok) {
                const json = await response.json()
                vm.showSnackBar(json.message || 'Ha ocurrido un error intentando consultar la agenda')
                return
            }

            const json = await response.json()
            vm.schedule = json.result.schedule
            if (firstLoad) {
                vm.originalEvents = json.result.schedule.schedule_events
            }

        },
        debouncedSetAutoScheduledEvents: debounce(function () {
            this.setNewAutoScheduleEvents()
        }, 500)
    },
    computed: {
        ...mapState(['currentProvider', 'currentUser']),
        scheduleEventsHasChanged() {
            var vm = this
            return vm.allEvents.length > 0
        },
        allEvents() {
            var vm = this
            const newEvents = vm.events.filter((event) => event.isNew)
            const eventsToDelete = vm.events.filter(event => event.delete && event.delete === 1)
            return [...newEvents, ...eventsToDelete]
        }
    },
    watch: {
        locked(val) {


            var vm = this
            if (!val) {
                vm.getScheduleDetails(true)
                vm.lockingOthers = setInterval(function () {
                    whisperOnPrivate(`schedule.${vm.scheduleId}`, 'lock', {
                        by: vm.currentUser.id
                    })
                }, 300)
            } else {
                clearInterval(vm.lockingOthers)
            }

        },
        schedule(schedule) {
            if (schedule) {
                var vm = this
                vm.name = schedule.name
                vm.intervalStart = schedule.interval_start
                vm.intervalEnd = schedule.interval_end
                vm.intervalCount = schedule.interval_count
                vm.intervalMinutes = schedule.interval_minutes
                vm.weekDays = schedule.week_days
                vm.appointmentAnticipationHours = schedule.appointment_anticipation_hours
                vm.appointmentLimitDays = schedule.appointment_limit_days

                vm.events = JSON.parse(JSON.stringify(schedule.schedule_events))

            }
        },
        date(val) {
            this.$refs.calendar.setDate(val)
        },
        currentWeek(val, old) {

            if (val.start !== old.start && val.end !== old.end) {
                this.getScheduleDetails(true)
            }
        },
        events() {
            const vm = this
            vm.debouncedSetAutoScheduledEvents()
        }
    }
}
</script>

<style scoped>

.client {
    background-color: #d5d5d5 !important;
    border: 1px solid #333 !important;
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 900;
    background-color: rgba(255, 255, 255, .7);
}

.interval-block {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: .9em;
}

.month-nav-header {
    display: inline-block;
    width: 170px;
}

>>> .v-list__tile {
    height: 60px;
}

.month-title {
    cursor: pointer;
}

.kimsa-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    border: none;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    width: 100%;
    margin: 0px;
    position: absolute;
    pointer-events: none;
}

.kimsa-event.locked {
}

</style>